import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

/* eslint-disable-next-line */
const StatusCircle = ({ status }) => {
  const colors = {
    rejected: { main: '#ff6058', border: '#dc3f3f' },
    pending: { main: '#ffbf2f', border: '#d49600' },
    approved: { main: '#28cc41', border: '#00a716' },
    live: { main: '#5d81ec', border: '#4666c2' },
  };

  if (Object.keys(colors).indexOf(status) === -1) {
    return (
      <Container>
        <Circle
          mainColor="white"
          borderColor="white"
        />
      </Container>
    );
  }

  return (
    <Container>
      <Circle
        mainColor={colors[status].main}
        borderColor={colors[status].border}
      />
    </Container>
  );
};

StatusCircle.propTypes = {
  status: PropTypes.string.isRequired,
};

export default StatusCircle;

const Container = styled.div`
  margin-right: 5px;
  margin-top: -1px;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Circle = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 25px;
  background-color: ${props => props.mainColor};
  border: 1px solid ${props => props.borderColor};
`;




// WEBPACK FOOTER //
// ./client/Dashboard/components/StatusCircle.js